import { Component, OnInit, OnChanges, SimpleChanges, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

import { UsuarioService } from './usuarios.service';
import { Usuario } from './../usuario/usuario';

import { PerfilService } from './../perfis/perfil.service';
import { Perfil } from './../perfis/perfil';

declare var Materialize:any;

@Component({
  selector: 'app-usuarios',
  templateUrl: './editar.component.html',
  styleUrls: ['./usuarios.component.css'],
  providers: [UsuarioService, PerfilService]
})

export class EditarUsuarioComponent  implements OnInit, AfterViewChecked{
  titulo: string = "Editar Usuario";
  public usuario: Usuario;
  public perfils: Perfil[];
  public busy: Promise<any>;

  getUsuario(): void {
    this.route.params.forEach((params: Params) => {
      let id = params['id'];
      if(id !== undefined ){
        this.busy = this.usuarioService.getUsuario(id)
          .then((usuario) =>  this.exibir(usuario));
      }
    });
  }

  exibir(usuario: any): void{
    console.log(usuario);
    this.usuario = usuario;
  }

  getPerfis(): void{
    this.perfilService.getPerfis()
        .then((response) => this.perfils = response);
  }

  salvar():any{
    if(this.usuario.id){
      this.busy = this.usuarioService.saveUsuario(this.usuario)
          .then((response) => this.goBack() );
    }
  }

  goBack(): void{
      this.router.navigate(['/usuarios']);
  }

  change(e:any): void{
    this.usuario.perfil_ids = e;
  }

  constructor( private usuarioService: UsuarioService,private router: Router, private route: ActivatedRoute, private perfilService: PerfilService) {

  }

  ngOnInit() {
    this.usuario = new Usuario();
    this.getUsuario();
    this.getPerfis();
  }

  ngAfterViewChecked() {
    Materialize.updateTextFields();
  }
}



// WEBPACK FOOTER //
// ./src/app/usuarios/editar.component.ts